import typeCheck from 'common/util/typeCheck';

import { onLogicSuccess } from 'client/actions/Auth/login';

import { SR_API_ACTION_GUARANTOR_SIGNUP } from 'api/actionTypes';

export default async function guarantorSignup({ state, apiClient }, params) {
  typeCheck('params::Object', params);

  const { name, phone, password, guarantorForUserId, guarantorForHouseholdId } = params;

  const analyticsSessionId = state.get(['analytics', 'analyticsSessionId']);
  const experimentActiveVariants = state.get(['analytics', 'experiments', 'activeVariants']);

  await apiClient.postWithState({
    action: SR_API_ACTION_GUARANTOR_SIGNUP,
    state: state,
    payload: {
      name,
      phone,
      password,
      guarantorForUserId,
      guarantorForHouseholdId,
      analyticsSessionId,
      experimentActiveVariants,
    },
    async onSuccess({ user }) {
      await onLogicSuccess({
        state,
        apiClient,
        user,
      });
    },
  });
}
